import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M0.667969 7.99996C0.667969 3.94987 3.95121 0.666626 8.0013 0.666626C8.7419 0.666626 9.45685 0.776409 10.1308 0.98059L9.74417 2.25664C9.19423 2.09003 8.60949 1.99996 8.0013 1.99996C4.68759 1.99996 2.0013 4.68625 2.0013 7.99996C2.0013 11.3137 4.68759 14 8.0013 14C8.60949 14 9.19423 13.9099 9.74417 13.7433L10.1308 15.0193C9.45685 15.2235 8.7419 15.3333 8.0013 15.3333C3.95121 15.3333 0.667969 12.05 0.667969 7.99996Z"
      fill="#261B36"
    />
    <path
      d="M15.0207 10.1294C15.2249 9.45551 15.3346 8.74055 15.3346 7.99996C15.3346 7.25936 15.2249 6.54441 15.0207 5.87048L13.7446 6.25709C13.9112 6.80703 14.0013 7.39177 14.0013 7.99996C14.0013 8.60814 13.9112 9.19288 13.7446 9.74283L15.0207 10.1294Z"
      fill="#261B36"
    />
    <path
      d="M14.47 4.54243C13.7862 3.26576 12.7355 2.21505 11.4588 1.53123L10.8293 2.70659C11.8742 3.26626 12.735 4.12707 13.2947 5.17198L14.47 4.54243Z"
      fill="#261B36"
    />
    <path
      d="M11.4588 14.4687C12.7355 13.7849 13.7862 12.7342 14.47 11.4575L13.2947 10.8279C12.735 11.8728 11.8742 12.7337 10.8293 13.2933L11.4588 14.4687Z"
      fill="#261B36"
    />
    <path d="M7.33463 8.66663V3.33329H8.66797V7.33329H11.3346V8.66663H7.33463Z" fill="#261B36" />
  </svg>
);
